import React from "react";
import styles from "./waterfall-style.module.css";

import NumberFormat from "react-number-format";
import { Popover, OverlayTrigger } from "react-bootstrap";

export default class WaterfallMatrix extends React.PureComponent {
  renderBox(name, value, count, totalValue, className, width, indent, shouldHide) {
    const { hideCosts, isQuickRun, isMetrics } = this.props;

    return (
      <OverlayTrigger
        placement="top"
        trigger={["hover", "focus"]}
        overlay={
          <Popover id="popover-positioned-top" title={name}>
            <div className={styles.tooltip}>
              {!isQuickRun && (
                <div className={styles.tooltipHolder}>
                  <span className={styles.tooltipInfo}>{name + " Value:"}</span>
                  <span className={styles.tooltipNumber}>
                    <NumberFormat value={value.toFixed(2)} displayType={"text"} thousandSeparator={true} />
                  </span>
                </div>
              )}
              {/*
							{name !== 'Net ROI' && !isQuickRun && (
								<div>
									<div className={styles.tooltipHolder}>
										<span className={styles.tooltipInfo}>{'Total Value:'}</span>
										<span className={styles.tooltipNumber}>
											<NumberFormat
												value={totalValue.toFixed(2)}
												displayType={'text'}
												thousandSeparator={true}
											/>
										</span>
									</div>
									<div className={styles.tooltipHolder}>
										<span className={styles.tooltipInfo}>{'Percent of Overall:'}</span>
										<span className={styles.tooltipNumber}>
											{((value / totalValue) * 100).toFixed(2) + '%'}
										</span>
									</div>
								</div>
							)}
						*/}
              {name !== "Net ROI" && !isQuickRun && !isMetrics && (
                <div>
                  <div className={styles.tooltipHolder}>
                    <span className={styles.tooltipInfo}>{"Count:"}</span>
                    <span className={styles.tooltipNumber}>
                      <NumberFormat value={Math.round(count)} displayType={"text"} thousandSeparator={true} />
                    </span>
                  </div>
                </div>
              )}
              {isQuickRun && (
                <div>
                  <div className={styles.tooltipHolder}>
                    <span className={styles.tooltipInfo}>{isMetrics ? "Sum:" : "Count:"}</span>
                    <span className={styles.tooltipNumber}>
                      <NumberFormat value={Math.round(value)} displayType={"text"} thousandSeparator={true} />
                    </span>
                  </div>
                </div>
              )}
            </div>
          </Popover>
        }
      >
        <div
          className={className}
          style={{
            height: shouldHide ? "0%" : (name === "Net ROI" || name === "Net Correct") && !hideCosts ? "25%" : "50%",
            width: width,
            marginLeft: indent
          }}
        >
          {/*
					name === "Net ROI" && (
						<div className={styles.roiNumber}>
							<NumberFormat
								value={Math.round(value)}
								displayType={"text"}
								thousandSeparator={true}
								prefix={"$"}
							/>
						</div>
					)*/}
        </div>
      </OverlayTrigger>
    );
  }

  renderCategorical() {
    const {
      maxIteration,
      maxRunAmount,
      hideCosts,
      truePositiveLabel,
      trueNegativeLabel,
      falsePositiveLabel,
      falseNegativeLabel,
      isQuickRun,
      label
    } = this.props;

    const total = isQuickRun
      ? maxIteration.truePositive + maxIteration.falsePositive + maxIteration.trueNegative + maxIteration.falseNegative
      : maxRunAmount;

    const TP = isQuickRun ? maxIteration.truePositive : maxIteration.truePositiveVal;
    const FP = isQuickRun ? maxIteration.falsePositive : maxIteration.falsePositiveVal;
    const TN = isQuickRun ? maxIteration.trueNegative : maxIteration.trueNegativeVal;
    const FN = isQuickRun ? maxIteration.falseNegative : maxIteration.falseNegativeVal;

    return (
      <div className={styles.trueVal}>
        <div className={styles.background}>
          {this.renderBox(
            truePositiveLabel,
            TP,
            maxIteration.truePositive,
            maxIteration.totalVal,
            styles.truePositive,
            (TP / total) * 100 + "%",
            undefined
          )}
          {this.renderBox(
            falsePositiveLabel,
            FP,
            maxIteration.falsePositive,
            maxIteration.totalVal,
            styles.falsePositive,
            (FP / total) * 100 + "%",
            (TP / total) * 100 - (FP / total) * 100 + "%"
          )}
          {this.renderBox(
            trueNegativeLabel,
            TN,
            maxIteration.trueNegative,
            maxIteration.totalVal,
            styles.trueNegative,
            (TN / total) * 100 + "%",
            (TP / total) * 100 - (FP / total) * 100 + "%",
            hideCosts
          )}
          {this.renderBox(
            falseNegativeLabel,
            FN,
            maxIteration.falseNegative,
            maxIteration.totalVal,
            styles.falseNegative,
            (FN / total) * 100 + "%",
            (TP / total) * 100 - (FP / total) * 100 - (FN / total) * 100 + (TN / total) * 100 + "%",
            hideCosts
          )}
        </div>
        {isQuickRun
          ? this.renderBox(
              "Net Correct",
              maxIteration.showConstraint ? maxIteration.constraintROI : maxIteration.roi,
              0,
              maxIteration.totalVal,
              styles.roi,
              hideCosts
                ? (TP / total) * 100 - (FP / total) * 100 + "%"
                : (TP / total) * 100 - (FP / total) * 100 - (FN / total) * 100 + (TN / total) * 100 + "%"
            )
          : this.renderBox(
              "Net ROI",
              maxIteration.showConstraint ? maxIteration.constraintROI : maxIteration.roi,
              0,
              maxIteration.totalVal,
              styles.roi,
              hideCosts
                ? (TP / total) * 100 - (FP / total) * 100 + "%"
                : (TP / total) * 100 - (FP / total) * 100 - (FN / total) * 100 + (TN / total) * 100 + "%"
            )}
      </div>
    );
  }

  renderContinuous() {
    const { metrics, isQuickRun } = this.props;

    const over = isQuickRun ? metrics.sum_over_predict : metrics.overImpact;
    const under = isQuickRun ? metrics.sum_under_predict : metrics.underImpact;

    const total = over + under;

    return (
      <div className={styles.trueVal}>
        <div className={styles.background}>
          {this.renderBox(
            isQuickRun ? "Sum Overestimate" : "Over Impact",
            over,
            undefined,
            total,
            styles.falseNegative,
            (over / total) * 100 + "%",
            undefined
          )}
          {this.renderBox(
            isQuickRun ? "Sum Underestimate" : "Under Impact",
            under,
            undefined,
            total,
            styles.falseNegative,
            (under / total) * 100 + "%",
            (over / total) * 100 + "%"
          )}
          {this.renderBox(
            isQuickRun ? "Absolute Error" : "Total Impact",
            total,
            undefined,
            total,
            styles.roi,
            "100%",
            "0%"
          )}
        </div>
      </div>
    );
  }

  render() {
    const { metrics } = this.props;

    const isMetrics = Object.keys(metrics).length > 0;

    return (
      <div className={styles.valueMatrixHolder}>{isMetrics ? this.renderContinuous() : this.renderCategorical()}</div>
    );
  }
}
